import { useQueryParams } from '../../hooks';

const useSidebarSectionLink = (path) => {
  let { mapId } = useQueryParams();
  return `${path}?pathId=${mapId}`;
};

export default useSidebarSectionLink;
